var map = {
	"./default_bg_2.png": 697,
	"./default_bg_2_2.png": 698,
	"./default_bg_2_3.png": 699,
	"./default_bg_2_4.png": 700,
	"./default_bg_2_5.png": 701,
	"./default_bg_2_6.png": 702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1864;